import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  errorText?: string;
  requiredMark?: boolean;
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(function TextField(
  { label, hint, errorText, requiredMark, id, className, ...rest },
  ref,
) {
  const fieldId = id ?? (label ? `field-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : undefined);
  return (
    <div className="flex flex-col gap-1.5">
      {label ? (
        <label htmlFor={fieldId} className="text-sm font-medium text-ink">
          {label}
          {requiredMark ? <span className="ml-0.5 text-danger">*</span> : null}
        </label>
      ) : null}
      <input
        ref={ref}
        id={fieldId}
        aria-invalid={errorText ? true : undefined}
        className={cn(
          'h-10 rounded-lg border bg-surface px-3 text-sm text-ink',
          'placeholder:text-ink-subtle focus:outline-none focus:ring-2 focus:ring-brand',
          errorText ? 'border-danger' : 'border-line',
          className,
        )}
        {...rest}
      />
      {errorText ? (
        <p className="text-xs text-danger">{errorText}</p>
      ) : hint ? (
        <p className="text-xs text-ink-subtle">{hint}</p>
      ) : null}
    </div>
  );
});
